<script>
  export let policyToggle;
</script>

<div class="footer-bg">
  <div class="footer">
    <span class="footer-text" style="margin-left:15px">th3syndicate.io</span>
    <!-- on:click={() => window.open("https://th3syndicate.io")} -->
    <span
      class="footer-text"
      style="margin-left:30px"
      on:click={() => (policyToggle = true)}>cookies & privacy policy</span
    >
  </div>
</div>

<style>
  span {
    color: white;
  }
  .footer-bg {
    width: 100%;
    background-color: rgba(217, 217, 217, 0.2);

    /* height: 32px; */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .footer {
    max-width: 1440px;
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
  }
  .footer-text {
    display: inline-block;
    position: relative;
    cursor: pointer;
    font-size: 11px;
    padding: 3px 0px;
  }
  .footer-text:after {
    content: "";
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: white;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
  }
  .footer-text:hover:after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
</style>
